import { MoonSolid, SunSolid } from '@allocab/allocab-icons';
import { useEffect, useState } from 'react';

import { storage } from '../services/storage/storage';

export const ThemeSwitch = () => {
  const [theme, setTheme] = useState<'dark' | 'light'>(() =>
    storage.getItem('color-theme') === 'dark' ||
    (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
      ? 'dark'
      : 'light',
  );

  const handleToggle = () => {
    if (theme === 'light') {
      setTheme('dark');
      storage.setItem('color-theme', 'dark');
    } else {
      setTheme('light');
      storage.setItem('color-theme', 'light');
    }
  };

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  return (
    <button
      type="button"
      className="text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 rounded-lg text-sm p-2.5"
      onClick={handleToggle}
    >
      {theme === 'light' ? (
        <SunSolid width={16} height={16} className="fill-current" />
      ) : (
        <MoonSolid width={16} height={16} className="fill-current" />
      )}
    </button>
  );
};
